import React from 'react';
import classnames from 'classnames';
import {Button} from '@br/br-components';

import StorageAPI from '../../apis/storage_api';

import ErrorMessages from '../atoms/errorMessages';
import PasswordInput from '../atoms/passwordInput';
import {WarnerMedia} from '../../endpoints';

class EmailSignup extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      errors: [],
    };
    this.onSubmit = this.onSubmit.bind(this);
  }

  onSubmit(event) {
    event.preventDefault();
    const {onboarding, screen} = this.props;
    this.setState({errors: []});
    const rawCookieData = StorageAPI.get('br_registration');
    const cookieData = rawCookieData ? JSON.parse(rawCookieData) : {};
    const first_name = cookieData.first_name.trim();
    const last_name = cookieData.last_name.trim();
    const username = cookieData.username.trim();
    const email = this._emailField.value;
    const password = this._passwordField.state.value;
    this.props
      .createAccount({email, password, username, first_name, last_name})
      .then(() => {
        this.props.stepCompleted();
        this.props.trackAction();
        this.props.trackEvent({
          tag_manager_event: 'account_created',
          accountType: 'email',
          screen,
          success: true,
          legacyAccount: false,
          socialOnboarding: onboarding,
        });
        this.props.mParticleUpdateAttributes({
          account_verified: false,
          loggedIn: false,
          signup_method: 'email',
        });
      })
      .catch((err) => {
        this.setState({errors: [err]});
        this.props.trackEvent({
          tag_manager_event: 'account_created',
          accountType: 'email',
          screen,
          success: false,
          legacyAccount: false,
          socialOnboarding: onboarding,
        });
        this.props.trackEvent({
          tag_manager_event: 'user_error',
          errorType: 'account_management',
          errorMessage: err?.output?.payload?.error || err?.message,
          errorCode: err?.data?.errorCode,
          page: 'email',
        });
      });
  }

  render() {
    const classes = classnames({
      molecule: true,
      emailSignup: true,
    });
    return (
      <form className={classes} onSubmit={this.onSubmit}>
        <h2>Sign Up with Email</h2>
        <p>Enter your email and create a password.</p>
        <input
          name="email"
          type="email"
          ref={(elem) => (this._emailField = elem)}
          required={true}
          placeholder="Email"
          pattern="^[^@\s]+@[^@\s]+\.[^@\s]+$"
        />
        <PasswordInput
          ref={(elem) => {
            this._passwordField = elem;
          }}
        />
        <ErrorMessages errors={this.state.errors} errorSet="email" />
        <Button type="submit">Continue</Button>
        <small>
          By selecting “Continue” you agree to the terms and conditions of the Bleacher Report{' '}
          <a href="/pages/terms">Terms of Use</a> and{' '}
          <a href={WarnerMedia.privacy()}>Privacy Policy</a>
        </small>
        {this.props.children}
      </form>
    );
  }
}

export default EmailSignup;
